import { getTutorialController } from '../tutorial/TutorialController';
import { isDecorationTutorialInProgress } from './helpers';

/**
 * Player opened decoration screen
 */
export async function decorationTutorialInProgressSequence() {
  // Skip tutorial start
  if (!isDecorationTutorialInProgress()) return;

  // Show tutorial popup
  await getTutorialController().handleEvent('decorationInProgress');
}

/**
 * Complete tutorial and give reward
 * It will be triggered from living room scene show
 */
export async function decorationTutorialFinishSequence() {
  // We didn't start tutorial yet
  if (!isDecorationTutorialInProgress()) return;

  // Give tutorial reward
  await getTutorialController().handleEvent('decorationFinished');
}
